/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Tut_Review_P1Inputs */

const en_wc_tut_review_p1 = /** @type {(inputs: Wc_Tut_Review_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`On the Review tab, turn on Track Changes. Insertions and deletions are marked in colour, and each one can be accepted or rejected, one by one or all at once.`)
};

/**
* | output |
* | --- |
* | "On the Review tab, turn on Track Changes. Insertions and deletions are marked in colour, and each one can be accepted or rejected, one by one or all at once." |
*
* @param {Wc_Tut_Review_P1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_tut_review_p1 = /** @type {((inputs?: Wc_Tut_Review_P1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Tut_Review_P1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_tut_review_p1(inputs)
});
export { wc_tut_review_p1 as "wc.tut.review.p1" }